class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.hiddenVariantSelect = this.querySelector('.js-hidden-variant-data');
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (document.querySelector("cart-notification")) {
      this.cartNotification = document.querySelector("cart-notification");
    }
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    let $this = this;
    if (document.querySelector("cart-notification")) {
      this.cartNotification.setActiveElement(document.activeElement);
    }
    const submitButton = this.querySelector('[type="submit"]');
    if(this.querySelector('#cart-errors')) this.querySelector('#cart-errors').style.display = 'none';

    
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: (!this.cart) ? ['cart-notification-button','cart-icon-bubble'] : this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    // var itemSelector = this.querySelector('.product__info-container [name="id"]');
    // let itemId = parseInt(itemSelector.getAttribute("value"));
    var itemSelector = this.form.id;
    let itemId = parseInt(itemSelector.value);

    // var itemQty = $(".product__info-container .quantity__input").val();
    var itemQty = parseInt(this.form.quantity.value);
    // var variantFinalStock = parseInt(itemSelector.getAttribute("max-qty"));
     var variantFinalStock = parseInt(Array.from(this.hiddenVariantSelect.options).filter(option => {
        return (option.value == itemId)
      })[0].dataset.inventoryQuantity);

    /*
    jQuery.getJSON("/cart.js", function (cart) {
      // now have access to Shopify cart object
      Object.entries(cart.items).forEach(([key, value]) => {
        if (value.id == itemId) {
          itemQty = itemQty + value.quantity;
        }
      });
    });
    */

    fetch('/cart.js')
    .then(data => {
      return data.json();
    })
    .then(responce => {
      let currentItem = responce.items.filter(item => {
        return (item.id == itemId)
      })[0];
      if(currentItem) itemQty += currentItem.quantity;

      if (itemQty <= variantFinalStock) {
        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");

        fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
          .then((response) => response.json())
          .then((parsedState) => {

            if(window.cartType == 'drawer' || window.cartType == 'notification'){
              $this.cart.renderContents(parsedState);
            }else if((window.cartType == 'page')){
              window.location.href = '/cart'
            }else{
              setTimeout(function () {
                $(".drawer").addClass("is-active");
                document.documentElement.style.overflow = "hidden";
                $("html").css({ height: "100vh" });
                $("body").css({ position: "fixed" });
              }, 500);
  
              setTimeout(function () {
                $(".drawer").addClass("is-visible");
                document.documentElement.style.overflow = "hidden";
                $("html").css({ height: "100vh" });
                $("body").css({ position: "fixed" });
              }, 1000);
  
              var $cartHolder = $(".cart-holder");

              document.getElementById('cart-icon-bubble').innerHTML = parsedState.sections['cart-icon-bubble'];
  
              $.ajax({
                url: "/cart",
              }).done(function (response) {
                var $html = $(response);
  
                var $element = $html.find(".cart_drawer_class").length
                  ? $html.find(".cart_drawer_class")
                  : $html.find(".cart-empty");
                $cartHolder.empty().html($element);
                //         cartCount++;
                //         $('.header .cart-counter').html(cartCount);
              });
            }
            
            // if (document.querySelector("cart-notification")) {
            //   this.cartNotification.renderContents(parsedState);
            // }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            if ($this.cart && $this.cart.classList.contains('is-empty')) $this.cart.classList.remove('is-empty');
            // $this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      } else {
        let errorText = `Only ${variantFinalStock} left in stock`;
        if(!this.querySelector('#cart-errors')){
          this.querySelector('.product-form__buttons').insertAdjacentHTML('afterend',`<span id="cart-errors" class="center error-text">${errorText}</span>`)
        } else {
          this.querySelector('#cart-errors').innerHTML = errorText;
          this.querySelector('#cart-errors').style.display = "block";
        }
        
        /*
        if ($(".product-form #cart-errors").length == 0) {
          $(
            '<span id="cart-errors" class="center error-text">Only ' +
              variantFinalStock + " left in stock</span>"
          ).insertAfter(".product-form__buttons");
        } else {
          $("#cart-errors").html(
            "Only " + variantFinalStock + " left in stock"
          );
          $(".product-form #cart-errors").show();
        }
        */
      }
      
    });
  }


  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define("product-form", ProductForm);
